module.exports = __webpack_public_path__ + "static/img/1_7_1.fd7649b3.jpg";